import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  TICKET_UPDATE,
  TICKET_FETCH,
  TICKETS_FETCH,
  TICKET_STATUS_FETCH,
  TICKETS_EXPORT_EXCEL,
} from '../redux/actions/types';
import { ticketFetchSuccess, ticketsFetchSuccess, ticketStatusFetchSuccess } from '../redux/actions/TicketActions';
import { showErrorMessage, showSuccessMessage, hideLoader } from '../redux/actions/NotifyActions';
import { authorizationHeader, getErrorMessage } from '../util/apiUtil';
import { intl } from '../i18n/IntlGlobalProvider';
import { reset } from 'redux-form';
import axios from 'axios';
import FileSaver from 'file-saver';
import moment from 'moment';
import _ from 'lodash';

// API
const ticketFetchRequest = async id =>
  await axios
    .get(`${process.env.REACT_APP_API_URL}/api/tickets/${id}`, {
      headers: authorizationHeader('bearer'),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });

const ticketsFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_URL}/api/tickets`;
  let params = { ...payload };
  params = _.omitBy(params, _.isEmpty);
  params.sort = 'created_date';
  params.order = 'desc';

  return await axios
    .get(url, {
      headers: authorizationHeader('bearer'),
      params: params,
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

const ticketStatusFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/status`;
  let params = { ...payload };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .get(url, {
      headers: authorizationHeader('bearer'),
      params: params,
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

const ticketsExportExcelRequest = async payload => {
  let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel`;
  let params = { ...payload };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .get(url, {
      headers: authorizationHeader('bearer'),
      params: params,
      responseType: 'blob',
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw error;
    });
};

const ticketUpdateRequest = async values => {
  return await axios
    .put(`${process.env.REACT_APP_API_URL}/api/tickets/${values._id}`, values, {
      headers: authorizationHeader('bearer'),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

// WORKER
function* ticketFetch({ payload }) {
  try {
    const data = yield call(ticketFetchRequest, payload);
    yield put(ticketFetchSuccess(data));
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* ticketsFetch({ payload }) {
  try {
    payload.from_created_date =
      payload.from_created_date instanceof Object
        ? payload.from_created_date.format('YYYY-MM-DD')
        : payload.from_created_date;
    payload.to_created_date =
      payload.to_created_date instanceof Object ? payload.to_created_date.format('YYYY-MM-DD') : payload.to_created_date;

    const data = yield call(ticketsFetchRequest, payload);
    yield put(ticketsFetchSuccess(data));
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* ticketStatusFetch({ payload }) {
  try {
    payload.from_created_date =
      payload.from_created_date instanceof Object
        ? payload.from_created_date.format('YYYY-MM-DD')
        : payload.from_created_date;
    payload.to_created_date =
      payload.to_created_date instanceof Object ? payload.to_created_date.format('YYYY-MM-DD') : payload.to_created_date;

    const data = yield call(ticketStatusFetchRequest, payload);
    yield put(ticketStatusFetchSuccess(data));
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* ticketsExportExcel({ payload }) {
  try {
    payload.from_created_date =
      payload.from_created_date instanceof Object
        ? payload.from_created_date.format('YYYY-MM-DD')
        : payload.from_created_date;
    payload.to_created_date =
      payload.to_created_date instanceof Object ? payload.to_created_date.format('YYYY-MM-DD') : payload.to_created_date;

    const data = yield call(ticketsExportExcelRequest, payload);
    FileSaver.saveAs(data, `redalerts_${moment().format('DDMMYYYY')}.xlsx`);
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* ticketUpdate({ payload }) {
  try {
    const data = yield call(ticketUpdateRequest, payload);
    if (data.success) {
      yield put(ticketFetchSuccess(data.success.result));
      yield put(showSuccessMessage(intl.formatMessage({ id: 'success.updated' })));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

// WATCHER
function* ticketFetchWatcher() {
  yield takeEvery(TICKET_FETCH, ticketFetch);
}

function* ticketsFetchWatcher() {
  yield takeEvery(TICKETS_FETCH, ticketsFetch);
}

function* ticketStatusFetchWatcher() {
  yield takeEvery(TICKET_STATUS_FETCH, ticketStatusFetch);
}

function* ticketsExportExcelWatcher() {
  yield takeEvery(TICKETS_EXPORT_EXCEL, ticketsExportExcel);
}
// --------------------------------------------------------------------------------------------
function* ticketUpdateWatcher() {
  yield takeEvery(TICKET_UPDATE, ticketUpdate);
}

export default function* rootSaga() {
  yield all([
    fork(ticketFetchWatcher),
    fork(ticketsFetchWatcher),
    fork(ticketStatusFetchWatcher),
    fork(ticketsExportExcelWatcher),
    fork(ticketUpdateWatcher),
  ]);
}
